import "@/assets/main.scss";
import { createApp } from "vue";
import App from "./app.vue";
import { router } from "./router";
import AppIcon from "./components/app-icon.vue";
import AppLoader from "./components/app-loader.vue";
import { i18n } from "./i18n";

async function mountApp() {
  const app = createApp(App);

  app.component("AppLoader", AppLoader);
  app.component("AppIcon", AppIcon);
  app.use(i18n);
  app.use(router);
  app.mount("#app");
}

mountApp();
